"use client";

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from "react";
import { getPortableTextComponents, type GetPortableTextComponentsOptions } from "@repo/ui/aops-components/portable-text-components";
import { PortableText } from "next-sanity";
import styles from "./PortableTextComponents.module.css";
const aopsClassNames: GetPortableTextComponentsOptions["classNames"] = {
  paragraph: styles.paragraph,
  heading: styles.heading,
  list: styles.list,
  listItem: styles.listItem,
  listNumber: styles.listNumber,
  listItemNumber: styles.listItemNumber
};
const aopsPortableTextComponents = getPortableTextComponents({
  classNames: aopsClassNames
}) as ComponentProps<typeof PortableText>["components"];
type PortableTextValue = ComponentProps<typeof PortableText>["value"];
type AopsPortableTextProps = {
  value: PortableTextValue;
  className?: string;
};
export function AopsPortableText(t0) {
  const $ = _c(7);
  const {
    value,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = [styles.portableText, className].filter(Boolean);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const classNames = t1.join(" ");
  let t2;
  if ($[2] !== value) {
    t2 = <PortableText value={value} components={aopsPortableTextComponents} />;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== classNames || $[5] !== t2) {
    t3 = <div className={classNames}>{t2}</div>;
    $[4] = classNames;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}